import React, { useEffect, useState, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import APIIntegration from "../../Images/ThirdPartyApi.svg";
import LocationTracking from "../../Images/location_tracking.svg";
import Footer from "../Footer/Footer.js";
import DetailsCard, {
  ThreeColumnContainer,
} from "../WhatWeDo/components/DetailsCard.js";
import logoTextData from "../../resources/logoTextData.json";
import imageHeader from "../../resources/imageHeader.json";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";
import ImageHeaderMain from "../WhatWeDo/components/ImageHeaderMain.js";
import LogoCard from "../WhatWeDo/components/LogoCard.js";
import logoData from "./../../resources/logoTextData.json";
import map from "../../Images/google_map.png";
import location from "../../Images/google-maps.png";
import experian from "../../Images/experian.jpg";
import usps_logo from "../../Images/us_postal_service.png";
import ca_logo from "../../Images/department_of_real-estate.png";
import zip_logo from "../../Images/zip.jpg";
import arcGIS from "../../Images/arcGIS.png";
import esri from "../../Images/esri.jpg";
import SiteXPro from "../../Images/SitexPro.jpg";
import Knight from "../../Images/B_knight.jpg";
import I18n from "../../Images/i18n.png";
import XML from "../../Images/xmldoc.jpg";
import crystal from "../../Images/crystal-reports.jpg";
import Aspose from "../../Images/aspose.jpg";
import localization from "../../Images/localization.jpg";
import PDF from "../../Images/pdf.png";
import Gx from "../../Images/gx.png";
import Itext from "../../Images/itxt.png";
import ms_identity from "../../Images/ms_identity.png";
import ms_active from "../../Images/ms_active.png";
import okta from "../../Images/okta.jpg";
import auth from "../../Images/auth_logo.jpg";
import aws from "../../Images/aws_cog.jpg";
import sendgrid from "../../Images/Capture.jpg";
import twillo from "../../Images/twillo.jpg";
import zang from "../../Images/zang.jpg";
import whatsapp from "../../Images/whatsapp.jpg";
import aws_ses from "../../Images/ses.jpg";
import great_plains_logo from "../../Images/greatplains.jpg";
import sage from "../../Images/sage.jpg";
import microsoft_dynamics from "../../Images/microsoft_dynamics.jpg";
import quickbooks from "../../Images/quickbooks.jpg";
import stripe from "../../Images/stripe.jpg";
import paypal from "../../Images/paypal.jpg";
import ach_logo from "../../Images/ach_logo.jpg";
import cc_avenue from "../../Images/cc_avenue.jpg";
import ContactUs from "../Contact/ContactUs.js";
import RealEstateTechstack from "../Techstack/RealEstateTechstack.js";
import Realestate from "../../Images/Real-estate-software-development.svg";
import Documentation from "../../Images/Documentation.svg";
import Communication from "../../Images/communication.svg";
import Identity from "../../Images/safe.svg";
import Accounting from "../../Images/accounting_svg.svg";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Database } from "feather-icons/dist/icons/database.svg";
import { ReactComponent as Location } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as Dollar } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Message } from "feather-icons/dist/icons/message-square.svg";
import { ReactComponent as Key } from "feather-icons/dist/icons/key.svg";
import IconCard from "../WhatWeDo/components/IconCard.js";
import thirdPartyApiIintegration from "../../Images/thirdPartyApiIintegration.jpg";
import SliderPage from "../WhatWeDo/components/SliderPage.js";
import WhoWeAre from "../WhoWeAre/WhoWeAre.js";
import Slider from "../WhatWeDo/components/Slider.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";

const LogoContainer = tw.div`flex lg:justify-end absolute mb-10 z-1 w-full`;
const LogoText = tw.h5`ml-0 text-6xl pt-5 text-indigo-600 font-bold text-white`;
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg scale-125`;
const Description = tw.p`px-6 font-semibold py-2  text-xl text-gray-900 text-justify`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const Padding = tw.div`pb-12`;

const imgStyle = { width: "40px", height: "40px" };

let data = [
  {
    imageSrc: <Location style={imgStyle} />,
  },
  {
    imageSrc: <Database style={imgStyle} />,
  },
  {
    imageSrc: <Code style={imgStyle} />,
  },
  {
    imageSrc: <Dollar style={imgStyle} />,
  },
  {
    imageSrc: <Message style={imgStyle} />,
  },
  {
    imageSrc: <Key style={imgStyle} />,
  },
];

const integrationSpecialities =
  logoTextData.thirdpartyintegrations.integrationspecialities.map(
    (item, index) => (
      <IconCard
        readmore={true}
        key={index}
        title={item.title}
        url={item.url}
        description={item.description}
        imageSrc={data[index].imageSrc}
      />
    )
  );

const ThirdPartyIntegrationPDF = () => {
  const cardData = {
    loactionIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[0].insideData,
    realEstateIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[1].insideData,
    DocumentationIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[2].insideData,
    AccountingIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[3].insideData,
    MessagingIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[4].insideData,
    IdentityIntegrationData:
      logoData.thirdpartyintegrations.integrationspecialities[5].insideData,
  };

  let ImagesArray = {
    locationIntegrationImages: [
      {
        img1: map,
        img2: location,
      },
      {
        img1: usps_logo,
        img2: ca_logo,
        img3: zip_logo,
      },
      {
        img1: experian,
      },
      {
        img1: arcGIS,
        img2: esri,
      },
    ],
    realEstateIntegrationImages: [
      {
        img1: SiteXPro,
        img2: Knight,
      },
    ],
    documentationIntegrationImages: [
      {
        img1: Aspose,
        img2: Itext,
        img3: crystal,
      },
      {
        img1: XML,
        img2: PDF,
      },
      {
        img1: Gx,
        img2: localization,
        img3: I18n,
      },
    ],
    accountingIntegrationImages: [
      {
        img1: great_plains_logo,
        img2: microsoft_dynamics,
        img3: quickbooks,
        img4: sage,
      },
      {
        img1: paypal,
        img2: stripe,
        img3: cc_avenue,
        img4: ach_logo,
      },
    ],
    messagingIntegrationImages: [
      {
        img1: sendgrid,
        img2: twillo,
        img3: zang,
        img4: aws_ses,
      },
      {
        img1: whatsapp,
      },
    ],
    identityIntegrationImages: [
      {
        img1: ms_identity,
        img2: ms_active,
      },
      {
        img1: aws,
        img2: okta,
        img3: auth,
      },
    ],
  };

  let [current, setCurrent] = useState(0);

  let slidesData = [
    {
      image: thirdPartyApiIintegration,
      typeID: "element4",
      typedHead:
        "Seamlessly incorporate third-party APIs to enhance functionality and connectivity on your webpage.",
      heading1: "Third-Party ",
      heading2: "API Integrations",
      route: "/our-services/third-party-api-integrations",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  useEffect(() => {
    document.title = "Welcome to Iqura - Third-Party API Integrations";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iqura capabilities and experience with third-party systems and APIs will help you maximize your workflows with efficient and seamless integrations with your existing systems."
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Location &  Address Integrations, Real Estate Property &  Database Integrations, Document  automation, Accounting & Payment  Systems Integrations, Messaging &  Communications Integrations and Identity &  Access Management Integrations"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/third-party-api-integrations";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const [currentColor, setCurrentColor] = useState("%23EEF5FF");
  const svgStyle = {
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='${currentColor}' fill-opacity='0.9' d='M0,96L48,101.3C96,107,192,117,288,122.7C384,128,480,128,576,117.3C672,107,768,85,864,80C960,75,1056,85,1152,117.3C1248,149,1344,203,1392,229.3L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'/%3E%3C/svg%3E")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: "350px",
    // paddingTop: "90px",
  };

  return (
    <>
      <div className="flex justify-center" style={{ height: "100vh" }}>
        <div className="overflow-hidden relative  ">
          <LogoContainer>
            <div className="flex lg:justify-end w-full mr-16 ">
              <LogoText className="logoFontFamily">Iqura</LogoText>
            </div>
          </LogoContainer>
          <div
            className="flex transition-transform ease-out duration-300 "
            style={{
              transform: `translateX(-${current * 100}%)`,
            }}
          >
            {slides.map((s) => {
              return (
                <div className="z-22" style={{ width: "100%" }}>
                  {s}
                </div>
              );
            })}
          </div>

          <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
            {slides.map((s, i) => {
              return (
                <div
                  onClick={() => {
                    setCurrent(i);
                  }}
                ></div>
              );
            })}
          </div>
        </div>
      </div>
      <Container>
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -280}px`,
                padding: "40px",
                paddingTop: "25px",
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.ThirdPartyAPI}
                imgsource={APIIntegration}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
          <WhoWeArePDF whoweare="pdf" />
    
        <div>
          <Wrapper>
            <div style={{ height: "100vh", marginBottom:"110px" }}>
              <div className="px-20 scale-125 " style={{paddingTop:"250px"}}>
                <div>
                  <div id="apiintegration"></div>
                  <Padding>
                    <SubHeadings heading1="Api" heading2="Integrations" />
                  </Padding>
                  <ThreeColumnContainer>
                    {integrationSpecialities}
                  </ThreeColumnContainer>
                </div>
              </div>
            </div>

            {/* ----------------------- Location ---------------------------------------- */}
            <div style={{ height: "100vh", marginTop: "-5px", marginBottom:"90px" }}>
              <div  style={{ transform:"scale(1.30)", marginTop:"20px"}}>
              <div className="pt-8 " style={svgStyle}>
                <div className="px-20 mt-5">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.LocationAddress}
                    imgsource={LocationTracking}
                    TypingId="locationTyping"
                  />
                </div>
              </div>
              <LogoCard
                card="pdf"
                ispdf={true}
                data={cardData.loactionIntegrationData}
                imgArr={ImagesArray.locationIntegrationImages}
              />
              </div>
            </div>

            {/* ----------------------- RealEstate ---------------------------------------- */}

            <div style={{ height: "100vh" , marginTop:"-145px"}}>
              <div  style={{ transform:"scale(1.30)", marginTop:"20px"}}>
              <div className="" style={svgStyle}>
                <div className="px-20 pt-20">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.RealEstatePropertyDatabase}
                    imgsource={Realestate}
                    TypingId="RealEstateTyping"
                  />
                </div>
                <LogoCard
                  card="pdf"
                  data={cardData.realEstateIntegrationData}
                  imgArr={ImagesArray.realEstateIntegrationImages}
                />
                </div>
              </div>
            </div>

            {/* ----------------------- Documentation ---------------------------------------- */}
            <div style={{ height: "100vh"}}>
              <div  style={{ transform:"scale(1.30)"}}>
              <div className="" style={svgStyle}>
                <div className="px-20 pt-20">
                <ImageHeaderMain
                    imageHeaderData={imageHeader.DocumentAutomation}
                    imgsource={Documentation}
                    TypingId="DocumentTyping"
                  />
                </div>
                <LogoCard
                card="pdf"
                ispdf={true}
                data={cardData.DocumentationIntegrationData}
                imgArr={ImagesArray.documentationIntegrationImages}
              />
                </div>
              </div>
            </div>


            {/* <div style={{ height: "100vh"}}>
            <div  style={{ transform:"scale(1.30)", marginTop:"70px"}}>
              <div className="" style={svgStyle}>
                <div className="px-20">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.DocumentAutomation}
                    imgsource={Documentation}
                    TypingId="DocumentTyping"
                  />
                </div>
              </div>
              <LogoCard
                card="pdf"
                ispdf={true}
                data={cardData.DocumentationIntegrationData}
                imgArr={ImagesArray.documentationIntegrationImages}
              />
              </div>
            </div> */}

            {/* ----------------------- Accounting ---------------------------------------- */}


            <div style={{ height: "100vh"}}>
              <div  style={{ transform:"scale(1.30)"}}>
              <div className="" style={svgStyle}>
                <div className="px-20 pt-20">
                <ImageHeaderMain
                    imageHeaderData={imageHeader.AccountsandPayment}
                    imgsource={Accounting}
                    TypingId="AccountTyping"
                  />
                </div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.AccountingIntegrationData}
                  imgArr={ImagesArray.accountingIntegrationImages}
                />
                </div>
              </div>
            </div>



            {/* <div style={{ height: "100vh" }}>
              <div className="pt-16" style={svgStyle}>
                <div className="px-20">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.AccountsandPayment}
                    imgsource={Accounting}
                    TypingId="AccountTyping"
                  />
                </div>
                <div className="pt-8"></div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.AccountingIntegrationData}
                  imgArr={ImagesArray.accountingIntegrationImages}
                />
              </div>
            </div> */}

            {/* ----------------------- Messaging ---------------------------------------- */}


            <div style={{ height: "100vh"}}>
              <div  style={{ transform:"scale(1.30)"}}>
              <div className="" style={svgStyle}>
                <div className="px-20 pt-20">
                <ImageHeaderMain
                    imageHeaderData={imageHeader.MessagingAndCommunication}
                    imgsource={Communication}
                    TypingId="MessageTyping"
                  />
                </div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.MessagingIntegrationData}
                  imgArr={ImagesArray.messagingIntegrationImages}
                />
                </div>
              </div>
            </div>


{/*             
            <div style={{ height: "100vh" }}>
              <div className="pt-16" style={svgStyle}>
                <div className="px-20">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.MessagingAndCommunication}
                    imgsource={Communication}
                    TypingId="MessageTyping"
                  />
                </div>
                <div className="pt-8"></div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.MessagingIntegrationData}
                  imgArr={ImagesArray.messagingIntegrationImages}
                />
              </div>
            </div> */}

            {/* ----------------------- Identity ---------------------------------------- */}


            <div style={{ height: "100vh"}}>
              <div  style={{ transform:"scale(1.30)"}}>
              <div className="" style={svgStyle}>
                <div className="px-20 pt-20">
                <ImageHeaderMain
                    imageHeaderData={imageHeader.IndentityAndAccess}
                    imgsource={Identity}
                    TypingId="IdentityTyping"
                  />
                </div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.IdentityIntegrationData}
                  imgArr={ImagesArray.identityIntegrationImages}
                />
                </div>
              </div>
            </div>
           



            {/* <div style={{ height: "100vh" }}>
              <div className="pt-16" style={svgStyle}>
                <div className="px-20">
                  <ImageHeaderMain
                    imageHeaderData={imageHeader.IndentityAndAccess}
                    imgsource={Identity}
                    TypingId="IdentityTyping"
                  />
                </div>
                <div className="pt-8"></div>
                <LogoCard
                  card="pdf"
                  ispdf={true}
                  data={cardData.IdentityIntegrationData}
                  imgArr={ImagesArray.identityIntegrationImages}
                />
              </div>
            </div> */}

            {/* ----------------------- Tech Stack ---------------------------------------- */}
            <div
        style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
      >
        <Slider />
      </div>
          </Wrapper>
         
        </div>
        <div style={{marginTop:"-65px"}}>
        <TeckStackPDF />
        <ContactUsPDF />
        </div>
      </Container>
 
    </>
  );
};

export default ThirdPartyIntegrationPDF;
